import { HttpErrorResponse } from "@angular/common/http";
import { Action, State, StateContext, Store } from "@ngxs/store";
import { throwError } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { PimaProject } from "src/app/shared/model/pima-project";
import { ProjectService } from "src/app/shared/services/project.service";
import { UnsubscribeService } from "src/app/shared/services/unsubscribe.service";
import { UnsubscribeActions } from "./actions";

export class UnsubscribeStateModel {
  error: string;
  message: string;
  projectInfo: PimaProject;
}

const defaultState: UnsubscribeStateModel = {
  error: null,
  message: null,
  projectInfo: null,
};

@State<UnsubscribeStateModel>({
  name: 'unsubscribe',
  defaults: defaultState
})

export class UnsubscribeState {

  constructor(
    private store: Store,
    private projectService: ProjectService,
    private unsubscribeService: UnsubscribeService
  ) {}

  @Action(UnsubscribeActions.GetProjectInfo)
  getProjectInfo(ctx: StateContext<UnsubscribeStateModel>, action: UnsubscribeActions.GetProjectInfo) {
    const state = ctx.getState();
    return this.projectService.getProjectById(action.projectId).pipe(
      tap(project => console.log('Project Info -> ', project)),
      map(project => {
        ctx.setState({
          ...state,
          projectInfo: project,
          error: null
        });
      }),
      catchError(error => this.store.dispatch(new UnsubscribeActions.SetError(error)))
    )
  }

  @Action(UnsubscribeActions.SetError)
  setError(ctx: StateContext<UnsubscribeStateModel>, action: UnsubscribeActions.SetError) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      message: null,
      error: action.error
    });
  }

  @Action(UnsubscribeActions.ClearErrorAndMessage)
  clearErrorAndMessage(ctx: StateContext<UnsubscribeStateModel>, action: UnsubscribeActions.ClearErrorAndMessage) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      message: null,
      error: null
    });
  }


  @Action(UnsubscribeActions.EmailUnsubscribe)
  emailUnsubscribe(ctx: StateContext<UnsubscribeStateModel>, action: UnsubscribeActions.EmailUnsubscribe) {
    const state = ctx.getState();
    return this.unsubscribeService.emailUnsubscribe(action.emailAddress, action.projectId).pipe(
      tap(result => console.log('Unsubscribe Result -> ', result)),
      map(result => {
        if (result.StakeEmail.toLocaleLowerCase() === action.emailAddress.toLocaleLowerCase()){
          ctx.setState({
            ...state,
            message: `Success, have you unsubscribed from ${action.projectId ? state.projectInfo.PROJECT_NR : 'ALL projects.'}`,
            error: null
          });
        }
      }),
      catchError(error => this.store.dispatch(new UnsubscribeActions.SetError(error)))
    )
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = '';

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = 'An error occurred:' + error.error.message;
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = error.error;
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError(errorMessage);
  }

}
